import { useToast } from "@chakra-ui/react";

import { ResponseError } from "@/api";

export const useOnError = (defaultMessage: string) => {
  const toast = useToast();
  return async (error: ResponseError) => {
    let description = defaultMessage;

    try {
      const json = await error.response.json();
      if (Object.values(json).length) {
        description = String(Object.values(json)[0]);
      }
    } catch (error) {
      //
    }

    toast({
      title: "Error",
      description,
      status: "error",
      duration: 5000,
      isClosable: true,
    });
  };
};
